import { Notification } from '../interfaces/Notification';
import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';

export function getNotifications(afterId?: number): Promise<Notification[]> {
  return api({
    url: ApiPath.Notifications,
    params: {
      afterId,
    },
  });
}
